import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { AuthRoutes } from '../../../routes/routeConstants/appRoutes';

// Layout route guard — place as the element on a Route that wraps protected children.
// Redirects to login if not authenticated; renders <Outlet /> (matched child route) if authenticated.
const AuthGuard = () => {
  const { authenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      navigate(AuthRoutes.LOGIN);
    }
  }, [authenticated, location.pathname]);

  if (!authenticated) return null;

  return <Outlet />;
};

export default AuthGuard;
